import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { changeFormDirection } from "../searchFlightsSlice";

function ViaCheckbox() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const direction = useAppSelector(
    (state) => state.searchFlights.form.direction
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const onChange = () =>
    dispatch(changeFormDirection(direction === "via" ? "from" : "via"));

  return (
    <div className="field">
      <div className="control">
        <label className="checkbox" title={t("RADIO_TITLE_VIA")}>
          <input
            type="checkbox"
            checked={direction === "via"}
            disabled={disabled}
            onChange={onChange}
          />
          {t("RADIO_LABEL_VIA")}
        </label>
      </div>
    </div>
  );
}

export default ViaCheckbox;
